export default __webpack_public_path__ + "static/pocket-drive-c217c7a84c33339ed204cc171cd2ec0e.png";